import './App.css';

import React, {useEffect, useState} from 'react';
import axios from 'axios';
import DataDisplay from './components/DataDisplay';

function App() {
  const [isValidToken, setIsValidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const [token, setToken] = useState(localStorage.getItem('authToken') || null);


  useEffect(() => {
    const verifyStoredToken = async () => {

      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        // Send token to backend for verification
        const response = await axios.post('/api/verify-token', {}, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.data.valid) {
          setIsValidToken(true);
        }
      } catch (err) {
        localStorage.removeItem('authToken'); // Remove invalid token
      } finally {
        setIsLoading(false);
      }
    };

    verifyStoredToken();
  }, [token]);


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/verify-code', { code: accessCode });
      localStorage.setItem('authToken', response.data.token); // Persist token
      setToken(response.data.token);
      setIsValidToken(true)
    } catch (err) {
      setError('Invalid code');
    }
  };

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }


  if (!isValidToken) {
    return (
      <div className="login-container">
        <form onSubmit={handleLogin}>
          <h2>Enter Access Code</h2>
          <input
            type="password"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
            placeholder="Enter Access Code"
          />
          <button type="submit">Submit</button>
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    );
  }


  return (
    <div className="App">
      <header className="App-header">
        <DataDisplay token={token} />
      </header>
    </div>
  );
}

export default App;
